import React, { Fragment } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import MEModal from '../../components/MEModal'
import PropTypes from 'prop-types'
import { bulkFixLmsIds } from '../actions'
import ButterToast, { Cinnamon } from 'butter-toast'

class BulkFixLmsId extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.submit = this.submit.bind(this)
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  bulkFixModalContent(authorized) {
    if (authorized) {
      return (
        <Fragment>
          <p>Attempt to resolve the Canvas IDs for all students?</p>
          <form onSubmit={e => e.preventDefault()}>
            <Button
              type="submit"
              className="btn-myed btn-primary-myed"
              bsStyle="primary"
              onClick={this.submit}
            >
              Yes
            </Button>
            <Button
              type="submit"
              className="btn-myed btn-default-myed"
              bsStyle="default"
              onClick={this.toggleModal}
            >
              No
            </Button>
          </form>
        </Fragment>
      )
    } else {
      let authLink = `/links/client_canvas.authorize_from_people/${this.props.coursenum}/`
      return (
        <Fragment>
          <h5 className="text-danger">Warning:</h5>
          <p>
            This course is not authorized with Canvas yet. You must authorize
            before continuning by clicking the button below.
          </p>
          <div className="text-center">
            <Button
              className="btn-myed btn-primary-myed"
              bsStyle="primary"
              href={authLink}
            >
              Authorize
            </Button>
          </div>
        </Fragment>
      )
    }
  }

  async submit(e) {
    e.preventDefault()
    this.toggleModal()

    let resp = await this.props.bulkFix()

    if (resp.status === 204) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            scheme={Cinnamon.Crunch.SCHEME_GREY}
            content="We have started bulk updating IDs, a completed task will appear once we are done."
            title="Success"
          />
        ),
      })
    } else {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            scheme={Cinnamon.Crunch.SCHEME_RED}
            content="There was an error trying to bulk update student IDs."
            title="Results"
          />
        ),
      })
    }
  }

  render() {
    if (this.props.lmsCourse) {
      return (
        <Fragment>
          <Button bsStyle="link" onClick={this.toggleModal}>
            <i className="fal fa-fw fa-tools" /> Bulk Fix Lms IDs
          </Button>
          <MEModal
            show={this.state.modalOpen}
            close={this.toggleModal}
            title="Confirm"
          >
            {this.bulkFixModalContent(this.props.authorized)}
          </MEModal>
        </Fragment>
      )
    } else {
      return null
    }
  }
}

BulkFixLmsId.propTypes = {
  lmsCourse: PropTypes.bool,
  authorized: PropTypes.bool,
  coursenum: PropTypes.string,
  bulkFix: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    lmsCourse: state.courseLms,
    coursenum: state.coursenum,
    authorized: state.authorized,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    bulkFix: () => dispatch(bulkFixLmsIds()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkFixLmsId)
